// removed by extract-text-webpack-plugin
module.exports = {"live-item-save":"live-item-save___q8bmK","button":"button___3jilm","icon":"icon___1UgVo","message-wrapper":"message-wrapper___2QDoe","title":"title___1GxHZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ItemSave/ItemSaveButton.scss
// module id = ohur
// module chunks = 57